import React, { useEffect } from "react";
import {
  SidebarWrapper,
  TopBarWrapper,
  MediaGridWrapper,
  FixedTopBarWrapper
} from "./GlobalMediaLibrary.styled";
import Sidebar from "./components/sidebar/Sidebar";
import TopBar from "./components/topbar/TopBar";
import FixedTopBar from "./components/fixed-top-bar/FixedTopBar";
import MediaGrid from "./components/media-grid/MediaGrid";
import { ActionsGlobalMediaLibrary } from "../../Actions/ActionsGlobalMediaLibrary/ActionsGlobalMediaLibrary";
import { withRefluxStore } from "../../Stores";
import GlobalMediaLibraryStore from "./GlobalMediaLibraryStore";
import { Store__System } from "@talentbait/shared-components";
import logger from "../../utils/LoggerFrontend";

const GlobalMediaLibrary = ({ filters, companyId, organization }) => {
  useEffect(() => {
    logger.log("GlobalMediaLibrary:mounted", "Global Media Library mounted", {
      companyId,
      organizationId: organization?.id,
      filters
    });

    return () => {
      try {
        ActionsGlobalMediaLibrary.setCompanyId("");
        ActionsGlobalMediaLibrary.setCompanyName("");
      } catch (error) {
        logger.log("error:GlobalMediaLibrary:cleanup:failed", "Cleanup failed", {
          error: error?.message || error,
          companyId
        });
      }
    };
  }, []);

  return (
    <>
      <FixedTopBarWrapper>
        <FixedTopBar companyId={companyId} />
      </FixedTopBarWrapper>
      <SidebarWrapper>
        <Sidebar filters={filters} />
      </SidebarWrapper>
      <TopBarWrapper>
        <TopBar filters={filters} />
      </TopBarWrapper>
      <MediaGridWrapper>
        <MediaGrid filters={filters} />
      </MediaGridWrapper>
    </>
  );
};

export default withRefluxStore(
  GlobalMediaLibrary,
  [GlobalMediaLibraryStore, Store__System],
  ["filters", "organization", "companyId"]
);
